import React, { useEffect, useState } from "react"
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
  createTheme,
} from "@mui/material"
import {
  SettingsOutlined,
  ChevronLeft,
  ChevronRightOutlined,
  HomeOutlined,
  Groups2Outlined,
  ReceiptLongOutlined,
  PublicOutlined,
  PointOfSaleOutlined,
  TodayOutlined,
  CalendarMonthOutlined,
  AdminPanelSettingsOutlined,
  TrendingUpOutlined,
  PieChartOutlined,
  LocalParkingOutlined,
} from "@mui/icons-material"
import { useLocation, useNavigate } from "react-router-dom"
import FlexBetween from "./FlexBetween"
import utill from "lib/utill"
import gpassImage from "../assets/gpass.png"
import { themeSettings } from "theme"

const Sidebar = ({
  user,
  drawerWidth,
  isSidebarOpen,
  setIsSidebarOpen,
  isNonMobile,
}) => {
  const { pathname } = useLocation()
  const [active, setActive] = useState("")
  const navigate = useNavigate()
  //const theme = useTheme()
  const theme = createTheme(themeSettings("dark", "sidebar"))

  const [navItems, setNavItems] = useState([])

  useEffect(() => {
    const user_level = utill.base64Decode(
      sessionStorage.getItem("x-a-d-l") ?? ""
    )

    if (user_level == 5) {
      const navItems = [
        {
          text: "Home",
          icon: <HomeOutlined />,
          scene: "dashboard",
        },
        {
          text: "지점 관리",
          icon: null,
        },
        {
          text: "지점 리스트",
          icon: <ReceiptLongOutlined />,
          scene: "kiosks",
        },
        {
          text: "사용자 관리",
          icon: null,
        },
        {
          text: "사용자 추가",
          icon: <Groups2Outlined />,
          scene: "users/new",
        },    
        {
          text: "사용자 삭제",
          icon: <Groups2Outlined />,
          scene: "users/userdelete",
        }, 
        {
          text: "사용자 리스트",
          icon: <Groups2Outlined />,
          scene: "users",
        },    
        {
          text: "출퇴근 리스트",
          icon: <ReceiptLongOutlined />,
          scene: "commutes",
        },
      ]
      setNavItems(navItems)
    } else if(user_level == 9) {
      const navItems = [
        {
          text: "Home",
          icon: <HomeOutlined />,
          scene: "dashboard",
        },
        {
          text: "지점 관리",
          icon: null,
        },
        {
          text: "지점 리스트",
          icon: <ReceiptLongOutlined />,
          scene: "kiosks",
        },
        {
          text: "사용자 관리",
          icon: null,
        },
        {
          text: "사용자 추가",
          icon: <Groups2Outlined />,
          scene: "users/new",
        },
        {
          text: "사용자 삭제",
          icon: <Groups2Outlined />,
          scene: "users/userdelete",
        }, 
        {
          text: "사용자 리스트",
          icon: <Groups2Outlined />,
          scene: "users",
        },
        {
          text: "출퇴근 리스트",
          icon: <ReceiptLongOutlined />,
          scene: "commutes",
        },
        {
          text: "어드민 관리",
          icon: null,
        },
        {
          text: "어드민 리스트",
          icon: <Groups2Outlined />,
          scene: "admins",
        },
      ]
      setNavItems(navItems)
    }
  }, [])

  useEffect(() => {
    setActive(pathname.substring(1))
  }, [pathname])

  return (
    <Box component="nav">
      {isSidebarOpen && (
        <Drawer
          open={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          variant="persistent"
          anchor="left"
          sx={{
            width: drawerWidth,
            "& .MuiDrawer-paper": {
              color: theme.palette.secondary[200],
              backgroundColor: theme.palette.background.alt,
              boxSizing: "border-box",
              borderWidth: isNonMobile ? 0 : "2px",
              width: drawerWidth,
            },
          }}
        >
          <Box width="100%">
            <Box m="1.5rem 2rem 2rem 3rem">
              <FlexBetween color={theme.palette.secondary.main}>
                <Box display="flex" alignItems="center" gap="0.5rem">
                  <Box
                    mr="10px"
                    component="img"
                    alt="profile"
                    src={gpassImage}
                    height="25px"
                    width="55px"
                    sx={{ objectFit: "cover" }}
                  />
                  <Typography variant="h4" fontWeight="bold">
                    근태관리
                  </Typography>
                </Box>
                {!isNonMobile && (
                  <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                    <ChevronLeft />
                  </IconButton>
                )}
              </FlexBetween>
            </Box>
            <List>
              {navItems.map(({ text, icon, scene }) => {
                if (!icon) {
                  return (
                    <Typography key={text} sx={{ m: "2.25rem 0 1rem 3rem" }}>
                      {text}
                    </Typography>
                  )
                }
                const lcText = scene.toLowerCase()

                return (
                  <ListItem key={scene} disablePadding>
                    <ListItemButton
                      onClick={() => {
                        navigate(`/${scene}`)
                        setActive(scene)
                      }}
                      sx={{
                        backgroundColor:
                          active === lcText
                            ? theme.palette.secondary[300]
                            : "transparent",
                        color:
                          active === lcText
                            ? theme.palette.primary[600]
                            : theme.palette.secondary[100],
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          ml: "2rem",
                          color:
                            active === lcText
                              ? theme.palette.primary[600]
                              : theme.palette.secondary[200],
                        }}
                      >
                        {icon}
                      </ListItemIcon>
                      <ListItemText primary={text} />
                      {active === lcText && (
                        <ChevronRightOutlined sx={{ ml: "auto" }} />
                      )}
                    </ListItemButton>
                  </ListItem>
                )
              })}
            </List>
          </Box>
        </Drawer>
      )}
    </Box>
  )
}

export default Sidebar
